import { render, staticRenderFns } from "./PhoneInfo.vue?vue&type=template&id=214e9d78&scoped=true&"
import script from "./PhoneInfo.vue?vue&type=script&lang=ts&"
export * from "./PhoneInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneInfo.vue?vue&type=style&index=0&id=214e9d78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214e9d78",
  null
  
)

export default component.exports